module.exports = __webpack_public_path__ + "media/images/landing/perspective-180d873e93b2959f9ae23e69e26877eb.png";